import { api } from '../lib/api';
import { $, errMsg } from '../lib/ui';

const SCREENS = ['/kasa', '/musteri', '/mutfak', '/yonetici'];
const form = $<HTMLFormElement>('f');
const user = $<HTMLInputElement>('u');
const pass = $<HTMLInputElement>('p');

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  $('err').textContent = '';
  try {
    const r = await api<{ home: string }>('/api/login', { method: 'POST', body: { username: user.value, password: pass.value } });
    const next = new URLSearchParams(location.search).get('next');
    location.href = next && SCREENS.includes(next) ? next : r.home;
  } catch (ex) {
    $('err').textContent = errMsg(ex);
    pass.select();
  }
});
user.focus();
